(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clon3d-custom-requests"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clon3d-requests')) {
    customElements.define('clon3d-requests', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.querySelectorAll('form').forEach((form) => {
          const key = `clon3d-request-v1:${location.host}:${location.pathname}:${form.id}`;
          const pendingKey = `${key}:pending`;
          const fields = Array.from(form.querySelectorAll('[data-draft]'));
          const warning = form.querySelector('[data-storage-warning]');
          const nativeSuccess = form.querySelector('[data-native-success]');
          let storage;
          let pending;
          try {
            storage = localStorage;
            const testKey = `${key}:test`;
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            pending = sessionStorage.getItem(pendingKey);
          } catch (_) { warning.hidden = false; }
          // A success flag by itself can be shared across contact forms. Never
          // clear another draft just because a different card was submitted.
          const returnedHere = location.hash === `#${form.id}`;
          const confirmed = Boolean(nativeSuccess && returnedHere && pending);
          if (confirmed) {
            nativeSuccess.hidden = false;
            try { storage?.removeItem(key); sessionStorage.removeItem(pendingKey); }
            catch (_) { warning.hidden = false; }
          } else {
            try {
              const raw = storage?.getItem(key);
              if (raw) {
                const draft = JSON.parse(raw);
                fields.forEach((field) => {
                  if (typeof draft[field.dataset.draft] === 'string') field.value = draft[field.dataset.draft];
                });
              }
            } catch (_) { warning.hidden = false; }
          }
          const save = () => {
            if (!storage) return;
            const draft = {};
            fields.forEach((field) => { draft[field.dataset.draft] = field.value; });
            try { storage.setItem(key, JSON.stringify(draft)); }
            catch (_) { warning.hidden = false; }
          };
          form.addEventListener('input', save, { signal });
          form.addEventListener('submit', () => {
            save();
            try { sessionStorage.setItem(pendingKey, String(Date.now())); }
            catch (_) { warning.hidden = false; }
            // Allow normal Shopify submission and spam protection to proceed.
          }, { signal });
        });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
